import Player from '@vimeo/player';
import axios from 'axios';

/**
 * Detects when a user plays a Vimeo video file and logs
 * the member activity to the projects Reporting feature.
 */

const divs = document.getElementsByClassName('responsiveVideo');

if (divs.length) {
    let track = true;

    const iframe = divs[0].getElementsByTagName('iframe')[0];

    const player = new Player(iframe);

    player.on('play', function() {
        if (track === true) {
            track = false;
            const url = window.location.href;
            const slug = url.substring(url.lastIndexOf('/') + 1);

            axios.get('/actions/reporting/log/video-play', {
                params: {
                    slug: slug
                }
            }).then(function(response) {
                console.log(response);
            }).catch(function(error) {
                console.log(error);
            });
        }
    });
}